import { Component, Input, OnInit } from '@angular/core';
import { ResultsGen } from '../models/Gen/ResultsGen';
import { GroupResultsGen } from '../models/Gen/GroupResultsGen';
import { Acad } from '../models/Gen/Acad';
import { BulletinGen } from '../models/Gen/BulletinGen';

@Component({
  selector: 'app-bodynote-gen',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class BodyNoteGenComponent implements OnInit {

  constructor() {
  }

  @Input() coef: number;
  @Input() period: Acad;
  @Input() tools;
  @Input() bulletin: BulletinGen;

  @Input()
  results: ResultsGen[] = [];

  @Input()
  fresults: ResultsGen[] = [];

  groupResults: GroupResultsGen[] = [];

  parseInt(i) {
    return parseInt(i);
  }

  ngOnInit(): void {
     this.getResultsCalcGen();
  }


  async getResultsCalcGen() {
  if (this.results.length==0) return;
      this.results.forEach(element => {
        if (element.cours.is_calc) {
             this.fresults.push(element);
         }
       });
    this.groupResults = this.getGroupResults(this.fresults);
    console.log( this.groupResults);
  }


  // getResultsCalc(bulletin) : ResultsGen [] {
  //   const results = [];
  //   bulletin.results.forEach(element => {
  //       if (element.cours.is_calc) {
  //           results.push(element);
  //       }
  //      });
  //   return results;
  // }

 getGroupResults(results: ResultsGen[]): GroupResultsGen[] {
  const groupMap = new Map<string, ResultsGen[]>();

  for (const result of results) {
    const catCode = result.cours.cat_code;
    if (!groupMap.has(catCode)) {
      groupMap.set(catCode, []);
    }
    groupMap.get(catCode)!.push(result);
  }

  const groupResultsList: GroupResultsGen[] = [];

  for (const [catCode, group] of groupMap.entries()) {
    const categorie =  this.period.categories.find(item => item.code === catCode);
    const note = group.reduce((sum, res) => sum + res.note_total, 0);
    const n = group[0].note ? group[0].note : [];
    const groupResult = new GroupResultsGen(catCode, categorie, group, note, categorie?.note_total, n);
    groupResultsList.push(groupResult);
  }

  return groupResultsList;
}
}
